// client/src/pages/CreditsPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authentication/AuthContext';
import { paymentApi } from '../services/paymentApi';
import { useStripe } from '@stripe/react-stripe-js';
import '../index.css';
import '../styles/AccountPage.css';

function CreditsPage() {
  const navigate = useNavigate();
  const { isAdmin, hasActiveSubscription, subscriptionUntil, credits } = useAuth();
  const [error, setError] = useState('');
  const [creditsToBuy, setCreditsToBuy] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const stripe = useStripe();
  
  // useEffect(() => {
  //   if (!user) {
  //     navigate('/login');
  //   }
  // }, [user, navigate]);

  const handleCreditPurchase = async () => {
    try {
      setIsLoading(true);
      const sessionId = await paymentApi.buyCredits(creditsToBuy);
      await stripe.redirectToCheckout({ sessionId });
    } catch (err) {
      setError('Error processing payment request');
      console.error('Payment error:', err);
      window.scrollTo(0, 0);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="hero hero-1 top-hero">
        {error && <div className="error-message">{error}</div>}

        <div className="container">
          <h2>Research Credits</h2>
          
            <h3>{isAdmin ? 'Unlimited' : credits} Research Credits </h3>
                  <p>Need more research credits? Purchase them individually at €2 per credit.</p>
                  
                  <div className="credit-purchase-controls">
                    <div className="credit-quantity-selector">
                      <label htmlFor="creditAmount">Number of credits:</label>
                      <div className="quantity-control">
                        <button 
                          onClick={() => setCreditsToBuy(Math.max(1, creditsToBuy - 1))}
                          className="quantity-btn"
                          disabled={isLoading}
                        >
                          -
                        </button>
                        <input 
                          type="number" 
                          id="creditAmount"
                          min="1" 
                          value={creditsToBuy}
                          onChange={(e) => setCreditsToBuy(Math.max(1, parseInt(e.target.value) || 1))}
                          className="quantity-input"
                          disabled={isLoading}
                        />
                        <button 
                          onClick={() => setCreditsToBuy(creditsToBuy + 1)}
                          className="quantity-btn"
                          disabled={isLoading}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    
                    <div className="credit-purchase-summary">
                      <p><strong>Total:</strong> €{(creditsToBuy * 2).toFixed(2)}</p>
                      <button 
                        className={`pricing-btn purchase-btn ${isLoading ? 'loading' : ''}`}
                        onClick={handleCreditPurchase}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner"></span>
                            Processing...
                          </>
                        ) : (
                          'Purchase Credits'
                        )}
                      </button>
                    </div>
            {hasActiveSubscription && (
              <div className="subscription-info-panel">
                <h3>Your Subscription</h3>
                <p><strong>Status:</strong> <span className="active-badge">Active</span></p>
                <p><strong>Renews:</strong> {new Date(subscriptionUntil).toISOString().split('T')[0]}</p>

                <p><strong>Research Credits:</strong> {credits} </p>
                <p>Your subscription automatically renews each month. You can manage your subscription from your <a href="/account">account page</a>.</p>
              </div>
            )}
            
            {!isAdmin && !hasActiveSubscription && (
              <div className="container pricing-card">
                {/* <h2>Subscription</h2>
                <p className="price">€20</p>
                <p className="period">monthly</p>
                <div className="credit-info">
                  <ul>
                    <li>10 research credits per week</li>
                    <li>Up to 15 questions per research</li>
                    <li>Up to 100 personas per research</li>
                    <li>Priority support</li>
                  </ul>
                </div> */}
                <button 
                  className="pricing-btn"
                  onClick={() => navigate('/become-beta')}
                >
                  Join the Beta Now
                </button>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditsPage;